var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPhotioWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 37,
    viewBox: "0 0 287 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_22811)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79705 9.88532H17.5937V18.6816H8.79705V9.88532ZM8.79705 27.4782H0V36.2749H8.79705V27.4782ZM8.79705 27.4782H26.3896V1.08867H0V18.682H8.79705V27.4782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.952 16.3155H102.823V0.939812H98.2012V36.314H102.823V20.9378H128.952V36.314H133.575V0.939812H128.952V16.3155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.603 36.314H241.225V0.939798H236.603V36.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.222 31.691C155.018 31.691 149.157 25.8305 149.157 18.6268C149.157 11.4232 155.018 5.56226 162.222 5.56226C169.426 5.56226 175.287 11.4232 175.287 18.6268C175.287 25.8305 169.426 31.691 162.222 31.691ZM162.222 0.939952C152.469 0.939952 144.535 8.87422 144.535 18.6268C144.535 28.3798 152.469 36.3137 162.222 36.3137C171.975 36.3137 179.909 28.3798 179.909 18.6268C179.909 8.87422 171.975 0.939952 162.222 0.939952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.313 31.6914C262.109 31.6914 256.248 25.8305 256.248 18.6268C256.248 11.4232 262.109 5.56226 269.313 5.56226C276.517 5.56226 282.377 11.4232 282.377 18.6268C282.377 25.8305 276.517 31.6914 269.313 31.6914ZM269.313 0.939952C259.56 0.939952 251.626 8.87422 251.626 18.6268C251.626 28.3798 259.56 36.3137 269.313 36.3137C279.066 36.3137 287 28.3798 287 18.6268C287 8.87422 279.066 0.939952 269.313 0.939952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9379 2.75817C81.2466 1.56867 79.2618 0.939812 77.1974 0.939812H51.8223V5.56212H77.1974C80.162 5.56212 82.5737 7.97425 82.5737 10.9388C82.5737 13.9034 80.162 16.3155 77.1974 16.3155H51.8223V36.314H56.445V20.9378H77.1974C79.2622 20.9378 81.2474 20.309 82.9379 19.1195C83.888 18.4513 84.7087 17.6306 85.3781 16.6797C86.5676 14.9888 87.1964 13.0036 87.1964 10.9388C87.1964 8.87446 86.5676 6.88924 85.3781 5.19798C84.709 4.24748 83.8884 3.4268 82.9379 2.75817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.342 5.56251H205.718V36.314H210.34V5.56251H225.716V0.939812H190.342V5.56251Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_22811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287,
    height: 35.3801,
    fill: "white",
    transform: "translate(0 0.939697)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPhotioWhite);
export default __webpack_public_path__ + "static/media/LogoPhotioWhite.0032475b56b7e269e02d450ac755de80.svg";
export { ForwardRef as ReactComponent };